import { Assets } from './Assets'

export const AllAssets = ({ assets, handleOnClick }) => {
  const allAssets = assets || []
  return (
    <Assets
      assets={allAssets}
      handleOnClick={handleOnClick}
      category={'AllAssets'}
    />
  )
}
